import mixpanel from 'mixpanel-browser'

export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter()
  const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN as string | undefined

  if (import.meta.env.VITE_MIXPANEL_ENABLED !== 'true') {
    // eslint-disable-next-line no-console
    console.log('Mixpanel is disabled, skipping Mixpanel initialization.')
    return {
      provide: {
        mixpanel: null as any
      }
    }
  }

  if (!mixpanelToken) {
    // eslint-disable-next-line no-console
    console.log('No Mixpanel token provided, skipping Mixpanel initialization.')
    return {
      provide: {
        mixpanel: null as any
      }
    }
  }

  // eslint-disable-next-line import/no-named-as-default-member
  mixpanel.init(mixpanelToken, {
    track_pageview: false,
    persistence: 'localStorage',
    ignore_dnt: true
  })

  router.afterEach((to) => {
    nextTick(() => {
      // eslint-disable-next-line import/no-named-as-default-member
      mixpanel.track('$pageview', { current_url: to.fullPath })
    })
  })

  return {
    provide: {
      mixpanel
    }
  }
})
